<template>
    <div >
      <div class='s_flex_bian_c m-b-10' v-for="(value,index) in links " :key="index" >
        <span>{{value.name}}</span>
         <a-button type="primary" @click="choose(value)">
            选择
         </a-button>
      </div>
    </div>
</template>

<script>
import { reactive, toRaw, computed, ref, toRefs } from "vue";
export default {
  name:"features",
  setup(pros,{emit}){
// {
//       "icon_id": "27392140",
//       "name": "电话",
//       "font_class": "dianhua",
//       "unicode": "e635",
//       "unicode_decimal": 58933
//     },
//     {
//       "icon_id": "27392110",
//       "name": "宣传视频@1x",
//       "font_class": "a-xuanchuanshipin1x",
//       "unicode": "e631",
//       "unicode_decimal": 58929
//     },
//     {
//       "icon_id": "27392111",
//       "name": "粉丝社群@1x",
//       "font_class": "a-fensishequn1x",
//       "unicode": "e632",
//       "unicode_decimal": 58930
//     },
//     {
//       "icon_id": "27392112",
//       "name": "公众号@1x",
//       "font_class": "a-gongzhonghao1x",
//       "unicode": "e633",
//       "unicode_decimal": 58931
//     },
//     {
//       "icon_id": "27392113",
//       "name": "检验报告@1x",
//       "font_class": "a-jianyanbaogao1x",
//       "unicode": "e634",
//       "unicode_decimal": 58932
//     },
//     {
//       "icon_id": "27391869",
//       "name": "溯源防伪查询",
//       "font_class": "suyuanfangweichaxun",
//       "unicode": "e630",
//       "unicode_decimal": 58928
//     },
//     {
//       "icon_id": "27391866",
//       "name": "溯源会员中心",
//       "font_class": "suyuanhuiyuanzhongxin",
//       "unicode": "e62e",
//       "unicode_decimal": 58926
//     },
//     {
//       "icon_id": "27391868",
//       "name": "溯源云店",
//       "font_class": "suyuanyundian",
//       "unicode": "e62f",
//       "unicode_decimal": 58927
//     }



    const state= reactive({
      links:[
        {
          name:'校验报告',
          link:"examine",
          key:"examine",
          icon:"a-jianyanbaogao1x"
        },
         {
          name:'粉丝社群',
          link:"group",
          key:"group",
          icon:"a-fensishequn1x"
        },
         {
          name:'宣传视频',
          link:"video",
          key:'video',
          icon:"a-xuanchuanshipin1x"
        },
         {
          name:'公众号',
          link:"public",
          key:"public",
          icon:"a-gongzhonghao1x"

        },
        {
          name:'会员中心',
          link:"center",
          key:'center',
          icon:"suyuanhuiyuanzhongxin"
        }
        ,{
          name:'云店',
          link:"/pages/index/index",
          key:'store',
          icon:"suyuanyundian"
        }
        ,{
          name:'防伪查询',
          link:"query",
          key:'query',
          icon:"suyuanfangweichaxun"
        } 
      ]
    })
    const choose=(data)=>{
        emit('select',data)
    }
    return{
      ...toRefs(state),
      choose
    }
  }
}
</script>